const debugMode = false;

export default class LoggingUtil {
  /**
   * @returns {Boolean} True only if we are in production domain or the localStorage.debug is set
   */
  static shouldLog = (key = 'debug') => {
    return (typeof localStorage !== 'undefined' && localStorage.getItem(key)) || debugMode;
  };

  static _debug = (msg, params) => {
    if (LoggingUtil.shouldLog()) {
      LoggingUtil.consoleFunc('debug', msg, params);
    }
  };

  static _count = (msg) => {
    if (LoggingUtil.shouldLog()) {
      console.count(msg);
    }
  };

  static _warn = (msg, params) => {
    if (LoggingUtil.shouldLog()) {
      LoggingUtil.consoleFunc('warn', msg, params);
    }
  };

  static _error = (msg, params) => {
    if (LoggingUtil.shouldLog()) {
      LoggingUtil.consoleFunc('error', msg, params);
    }
  };

  static consoleFunc = (funcName, msg, params) => {
    if (params && typeof params === 'object') {
      // https://developer.mozilla.org/en-US/docs/Web/API/Console/log#Logging_objects
      console[funcName](msg, JSON.parse(JSON.stringify(params)));
    } else if (params) {
      console[funcName](msg, params);
    } else {
      console[funcName](msg);
    }
  };
}

export const shouldLog = LoggingUtil.shouldLog;
export const _debug = LoggingUtil._debug;
export const _count = LoggingUtil._count;
export const _warn = LoggingUtil._warn;
export const consoleFunc = LoggingUtil.consoleFunc;

export function addEmphasis(str) {
  const lines = str.split('\n');
  const starsLen = Math.max(...lines.map((line) => line.length)) + 4;
  const stars = ''.padStart(starsLen, '*');
  return `${stars}\n` + '* ' + lines.join('\n* ') + `\n${stars}`;
}
